import request from '@/shared/api/request';

export const validateBucketName = (name: string): Promise<{ exists: boolean }> =>
  request({
    url: `/buckets/valid_name/${name}/`,
  });
